<template>
  <div id="dept-bar-chart" :style="size" style="display: flex;align-items:center;flex-direction: column">
    <e-charts :size="size" style="margin-top: 20px" :options="options" />
  </div>
</template>

<script>
import ECharts from '@/views/dataDisplay/components/ECharts'

const mycolor = ['#1089e7', '#f57474', '#56d0e3', '#f8b448', '#8b78f6']
export default {
  components: {
    ECharts,
  },
  props: {
    deptStats: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      size: {
        width: '100%',
        height: '400px',
      },
    }
  },
  computed: {
    options() {
      const deptNames = this.deptStats.map(item => item.deptName || '')
      const completionRates = this.deptStats.map(item => Number(item.completionRate || 0))
      
      return {
        title: {
          text: '安全检查完成率',
          left: 'center',
          top: '20px',
          textStyle: {
            color: '#333',
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: (params) => {
            const param = params[0]
            const originData = this.deptStats[param.dataIndex] || {}
            return `${param.name}<br/>总检查项: ${originData.totalCount || 0}项<br/>已完成: ${originData.completedCount || 0}项<br/>完成率: ${param.value}%`
          }
        },
        grid: {
          top: '20%',
          left: '10%',
          right: '10%',
          bottom: '15%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: deptNames,
          axisLabel: {
            color: '#333',
            fontSize: 12,
            rotate: 0,
            interval: 0
          },
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '完成率(%)',
          nameTextStyle: {
            color: '#333'
          },
          max: 100,
          axisLabel: {
            color: '#333',
            fontSize: 12,
            formatter: '{value}%'
          },
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#eee'
            }
          }
        },
        series: [
          {
            name: '完成率',
            type: 'bar',
            barWidth: 40,
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: '#333',
                fontSize: 12,
              },
              formatter: '{c}%'
            },
            itemStyle: {
              color: function (params) {
                const num = mycolor.length
                return mycolor[params.dataIndex % num]
              },
            },
            data: completionRates,
          },
        ],
      }
    }
  }
}
</script>

<style scoped>
</style>

